import { buildModelManager } from "../builder.js";
const DefaultEmailProviderConfigurationSelection = {
  __typename: true,
  id: true,
  apiKey: true,
  config: true,
  createdAt: true,
  fromEmail: true,
  isDefault: true,
  providerName: true,
  providerType: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "emailProviderConfiguration";
const pluralModelApiIdentifier = "emailProviderConfigurations";
;
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmailProviderConfigurationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEmailProviderConfiguration",
    operationReturnType: "CreateEmailProviderConfiguration",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      emailProviderConfiguration: {
        required: false,
        type: "CreateEmailProviderConfigurationInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEmailProviderConfigurations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateEmailProviderConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "updateEmailProviderConfiguration",
    operationReturnType: "UpdateEmailProviderConfiguration",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      emailProviderConfiguration: {
        required: false,
        type: "UpdateEmailProviderConfigurationInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEmailProviderConfigurations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateEmailProviderConfigurationsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "deleteEmailProviderConfiguration",
    operationReturnType: "DeleteEmailProviderConfiguration",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteEmailProviderConfigurations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "sendTestEmailProviderConfiguration",
    operationReturnType: "SendTestEmailProviderConfiguration",
    functionName: "sendTest",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      testEmail: { required: false, type: "String" },
      testPhone: { required: false, type: "String" },
      bypassDoubleOptIn: { required: false, type: "Boolean" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["testEmail", "testPhone", "bypassDoubleOptIn"],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkSendTestEmailProviderConfigurations",
    functionName: "bulkSendTest",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "sendTest",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkSendTestEmailProviderConfigurationsInput!]"
      }
    },
    paramOnlyVariables: ["testEmail", "testPhone", "bypassDoubleOptIn"],
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "upsertEmailProviderConfiguration",
    operationReturnType: "UpsertEmailProviderConfiguration",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      emailProviderConfiguration: {
        required: false,
        type: "UpsertEmailProviderConfigurationInput"
      }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEmailProviderConfigurationResult": { hasReturnType: false },
      "... on UpdateEmailProviderConfigurationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEmailProviderConfigurations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertEmailProviderConfigurationsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEmailProviderConfigurationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "emailProviderConfigurationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const EmailProviderConfigurationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEmailProviderConfigurationSelection,
  operations
);
export {
  DefaultEmailProviderConfigurationSelection,
  EmailProviderConfigurationManager
};
//# sourceMappingURL=EmailProviderConfiguration.js.map
